import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, HostListener } from '@angular/core';
import { MultistepsService } from '@app/modules/builder/base';
import { SessionService, StepsIdEnum, RequestTypesEnum, LookupsService, LimitlessUiService, ConstantsService,
          CompaniesEnum, LDCEnum, BuildingType} from '@app/base/core';
import { FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { CanComponentDeactivate } from '@app/base/shared';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DaterangepickerConfig } from 'ng2-daterangepicker';
import { SocoHttpService } from '@app/base/soco';
import { isNullOrUndefined } from 'util';


const moment = require('moment');
require('moment-weekday-calc');

declare var swal: any;
require('sweetalert');

@Component({
  selector: 'mixed-premise',
  templateUrl: './mixed.premise.component.html',
})
export class MixedPremiseComponent implements OnInit, CanComponentDeactivate {
  form: FormGroup;
  deliveryPressureResidential = [];
  deliveryPressureCommercial = [];
  loadTypeResidential = [];
  loadTypeCommercial = [];
  stepsIdEnum: typeof StepsIdEnum = StepsIdEnum;
  requestTypeEnum: typeof RequestTypesEnum = RequestTypesEnum;
  selectedIDsforResidential: any[] = [];
  selectedIDsforCommercial: any[] = [];
  companiesEnum: typeof CompaniesEnum = CompaniesEnum;
  ldcEnum: typeof LDCEnum = LDCEnum;
  buildingTypeListRes: BuildingType[] = [];
  buildingTypeListCom: BuildingType[] = [];
  deliveryPressOthersResidential = false;
  deliveryPressOthersCommMixuse = false;
  applianceCountR = true;
  applianceCountC = true;
  public btuLoadVal = 'BTU Load Value (Optional)';
  public btuLoadVal1 = 'BTU Load Value';
  public dateOptions: any = {
    alwaysShowCalendars: false,
    singleDatePicker: true,
    autoUpdateInput: true,
    showDropdowns: true,
    minDate: moment().addWorkdays(21),
    isInvalidDate: (date) => (date.day() === 0 || date.day() === 6)
  };

  @HostListener('window:beforeunload', ['$event']) onBeforeUnload(event) {
    if (this.socoHttp.sessionActive) {
      event.preventDefault();
      // Specially for chrome...
      event.returnValue = this.constantsSvc.changes;
    }
  }

  constructor(public wizardSvc: MultistepsService, private constantsSvc: ConstantsService,
    public sessionSvc: SessionService,
    private daterangepickerOptions: DaterangepickerConfig,
    public lookupSvc: LookupsService, public limitlessSvc: LimitlessUiService, public socoHttp: SocoHttpService) {
    this.daterangepickerOptions.skipCSS = true;
    this.deliveryPressureResidential = this.lookupSvc.deliveryPressure.filter(x =>
      x.usageType.toUpperCase() === RequestTypesEnum.Residential.toUpperCase());
    this.deliveryPressureCommercial = this.lookupSvc.deliveryPressure.filter(x =>
      x.usageType.toUpperCase() === RequestTypesEnum.Commercial.toUpperCase());
    this.loadTypeResidential = this.lookupSvc.loadType.filter(x =>
      x.usageType.toUpperCase() === RequestTypesEnum.Residential.toUpperCase());
    this.loadTypeCommercial = this.lookupSvc.loadType.filter(x =>
      x.usageType.toUpperCase() === RequestTypesEnum.Commercial.toUpperCase());
  }
  ngOnInit() {
    this.form = this.wizardSvc.getStepById(this.stepsIdEnum.PREMISE).form;

    // Logic to populate residential building Type List
    this.buildingTypeListRes = this.lookupSvc.buildingTypes.filter(b => b.unitType === this.constantsSvc.residentialType &&
      (this.wizardSvc.serviceAddress.state.short_name.toUpperCase() === this.companiesEnum.GA ? b.market === this.ldcEnum.AGLC :
        this.wizardSvc.serviceAddress.state.short_name.toUpperCase() === this.companiesEnum.TN ? b.market === this.ldcEnum.CGC :
          b.market === this.ldcEnum.VNG));

    // Logic to populate Commercial building Type List
    this.buildingTypeListCom = this.lookupSvc.buildingTypes.filter(b => b.unitType === this.constantsSvc.commercialType &&
      (this.wizardSvc.serviceAddress.state.short_name.toUpperCase() === this.companiesEnum.GA ? b.market === this.ldcEnum.AGLC :
        this.wizardSvc.serviceAddress.state.short_name.toUpperCase() === this.companiesEnum.TN ? b.market === this.ldcEnum.CGC :
          b.market === this.ldcEnum.VNG));

    const resPremiseArray = <FormArray>this.form.controls['residentialFormArray'];
    const commPremiseArray = <FormArray>this.form.controls['commercialFormArray'];
    resPremiseArray.controls.forEach((element, i) => {

      if (isNullOrUndefined(element.get('residentialDeliveryPressure').value)) {
        element.patchValue({
          residentialDeliveryPressure: this.lookupSvc.defaultResidentialPressure.lookupValues[0],
        });
      }

      if ((element.get('residentialDeliveryPressure').value &&
        element.get('residentialDeliveryPressure').value['itemName'].toUpperCase() === this.constantsSvc.otherAppliance) ||
       element.get('residentialDeliveryPressureOthers').value !== ''
       && !isNullOrUndefined(element.get('residentialDeliveryPressureOthers').value)) {
       this.deliveryPressOthersResidential = true;
     } else {
       this.deliveryPressOthersResidential = false;
       element.get('residentialDeliveryPressureOthers').clearValidators();
       element.get('residentialDeliveryPressureOthers').updateValueAndValidity();
     }
      const formArray = <FormArray>element.get('appliancesforResidential');
      if (formArray.length > 49) {
        this.applianceCountR = false;
      }
    });

    commPremiseArray.controls.forEach((element, i) => {

      if (isNullOrUndefined(element.get('commercialDeliveryPressure').value)) {
        element.patchValue({
          commercialDeliveryPressure: this.lookupSvc.defaultCommercialPressure.lookupValues[0],
        });
      }
      if ((element.get('commercialDeliveryPressure').value &&
        element.get('commercialDeliveryPressure').value['itemName'].toUpperCase() === this.constantsSvc.otherAppliance) ||
        element.get('commercialDeliveryPressureOthers').value !== '' &&
        !isNullOrUndefined(element.get('commercialDeliveryPressureOthers').value)) {
        this.deliveryPressOthersCommMixuse = true;
      } else {
        this.deliveryPressOthersCommMixuse = false;
        element.get('commercialDeliveryPressureOthers').clearValidators();
        element.get('commercialDeliveryPressureOthers').updateValueAndValidity();
      }

      const formArray = <FormArray>element.get('appliancesforCommercial');
      if (formArray.length > 49) {
        this.applianceCountC = false;
      }
    });


  }

  canDeactivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot, nextState: RouterStateSnapshot) {
    if (this.form) {
      return this.wizardSvc.canDeactivateStep(route, state, nextState);
    } else {
      return true;
    }

  }
  onItemSelect(eve: any, resArr: FormGroup) {
    if (isNullOrUndefined(eve)) {
      resArr.controls['residentialDeliveryPressureOthers'].reset('');
      resArr.controls['residentialDeliveryPressureOthers'].clearValidators();
      resArr.updateValueAndValidity();
      this.deliveryPressOthersResidential = false;
    } else if (eve.itemName === 'OTHER') {
      this.deliveryPressOthersResidential = true;
      this.form.controls['residentialDeliveryPressureOthers'].setValidators([Validators.required]);
    } else {
      resArr.controls['residentialDeliveryPressureOthers'].reset('');
      resArr.controls['residentialDeliveryPressureOthers'].clearValidators();
      resArr.controls['residentialDeliveryPressureOthers'].updateValueAndValidity();
      this.deliveryPressOthersResidential = false;
      resArr.updateValueAndValidity();
    }

    resArr.updateValueAndValidity();
  }

  onMixedCommItemSelect(eve: any, comArr: FormGroup) {
    if (isNullOrUndefined(eve)) {
      this.deliveryPressOthersCommMixuse = false;
      comArr.controls['commercialDeliveryPressureOthers'].reset('');

      comArr.controls['commercialDeliveryPressureOthers'].clearValidators();
      comArr.updateValueAndValidity();
    } else if (eve.itemName.toUpperCase() === 'OTHER') {
      this.deliveryPressOthersCommMixuse = true;
      comArr.controls['commercialDeliveryPressureOthers'].setValidators([Validators.required]);
    } else {
      comArr.controls['commercialDeliveryPressureOthers'].reset('');
      comArr.controls['commercialDeliveryPressureOthers'].clearValidators();
      comArr.controls['commercialDeliveryPressureOthers'].updateValueAndValidity();
      comArr.updateValueAndValidity();
      this.deliveryPressOthersCommMixuse = false;
    }
    comArr.updateValueAndValidity();
  }

  // delete  Residential premise
  selectIdfordeletion(id) {
    const control = <FormArray>this.form.controls['residentialFormArray'];
    control.removeAt(id);
  }

  // delete  commercial premise
  selectIdfordeletionComm(id) {
    const control = <FormArray>this.form.controls['commercialFormArray'];
    control.removeAt(id);
  }

  selectIDforCommercial(id, event: any) {
    if (event.target.checked) {
      this.selectedIDsforCommercial.push(id);
    } else if (!event.target.checked) {
      const index = this.selectedIDsforCommercial.indexOf(id);
      this.selectedIDsforCommercial.splice(index, 1);
    }
  }

  // used to add appliance for commercial
  addAppliancesforCommercial(element) {
    const formArray = <FormArray>element.get('appliancesforCommercial');
    formArray.push(new FormGroup({
      defaultAppliance: new FormControl(null, [Validators.required]),
      defaultApplianceOther: new FormControl(null),
      quantity: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.numericPattern)]),
      defaultValue: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.numericPatternwithZero)])
    })
    );
    if (formArray.length > 49) {
      this.applianceCountC = false;
    }
  }

  // used to delete appliance for commercial
  deleteApplianceforCommercial(element) {
    const control = <FormArray>element.get('appliancesforCommercial');
    if (this.selectedIDsforCommercial.length === 0) {
      swal(this.constantsSvc.premiseSwal1, this.constantsSvc.premiseSwal2);
    }
    this.selectedIDsforCommercial.sort((a, b) => b - a);
    this.selectedIDsforCommercial.forEach(function (index) {
      control.removeAt(index);
    });
    if (control.length < 50) {
      this.applianceCountC = true;
    }
    this.selectedIDsforCommercial = [];
  }

  // used to add appliance for residential
  addAppliancesforResidential(element) {
    const formArray = <FormArray>element.get('appliancesforResidential');
    formArray.push(new FormGroup({
      defaultAppliance: new FormControl(null, [Validators.required]),
      defaultApplianceOther: new FormControl(null),
      quantity: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.numericPattern)], ),
      defaultValue: new FormControl('', [Validators.pattern(this.constantsSvc.numericPatternwithZero)])
    })
    );
    if (formArray.length > 49) {
      this.applianceCountR = false;
    }
  }

  // used to delete appliance for residential
  deleteApplianceforResidential(element) {
    const control = <FormArray>element.get('appliancesforResidential');
    if (this.selectedIDsforResidential.length === 0) {
      swal(this.constantsSvc.premiseSwal1, this.constantsSvc.premiseSwal2);
    }
    this.selectedIDsforResidential.sort();
    this.selectedIDsforResidential.reverse();
    this.selectedIDsforResidential.forEach(function (index) {
      control.removeAt(index);
    });
    if (control.length < 50) {
      this.applianceCountR = true;
    }
    this.selectedIDsforResidential = [];
  }

    // To Add Premise Details for Residential Premise
    addpremiseForResidential() {
      const formArray = <FormArray>this.form.controls['residentialFormArray'];
      const panelIndex = formArray.controls.length;
      formArray.push(new FormGroup({
        panelNumber: new FormControl(panelIndex + 1),
        residentialHomeSqFt: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.numericPattern)]),
        residentialApproxDistanceFt: new FormControl('', Validators.pattern(this.constantsSvc.numericPattern)),
        residentialUnitDescription: new FormControl(null, [Validators.required]),
        residentialDeliveryPressure: new FormControl(this.lookupSvc.defaultResidentialPressure.lookupValues[0], Validators.required),
        residentialNoOfUnit: new FormControl('', Validators.pattern(this.constantsSvc.numericPattern)),
        // TODO: change true to check for value of new construction in type step to 'Yes'
        residentialStatusofConstruction: new FormControl(null, [Validators.required]),
        residentialNeedingServiceDate: new FormControl('', [Validators.pattern(this.constantsSvc.dateValidator)]),
        // TODO: change true to check for value of selected serviceable state in location page to 'Florida'
        residentialPropertyOwner: new FormControl(''),
        // TODO: change true to check for value of residentialDeliveryPressure to 'Other'
        residentialDeliveryPressureOthers: new FormControl(''),
        residentialBuildingType: new FormControl(null, [Validators.required]),
        appliancesforResidential: new FormArray([new FormGroup({
          defaultAppliance: new FormControl(null, [Validators.required]),
          defaultApplianceOther: new FormControl(null),
          quantity: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.numericPattern)]),
          defaultValue: new FormControl('', [Validators.pattern(this.constantsSvc.numericPatternwithZero)])
        })])
      })
      );

    }

     // To Add Premise Details for Commercial Premise
  addpremiseForCommercial() {
    const formArray = <FormArray>this.form.controls['commercialFormArray'];
    const panelIndex = formArray.controls.length;
    formArray.push(new FormGroup({
      panelNumber: new FormControl(panelIndex + 1),
      commercialHomeSqFt: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.numericPattern)]),
      commercialApproxDistanceFt: new FormControl('', Validators.pattern(this.constantsSvc.numericPattern)),
      commercialDeliveryPressure: new FormControl(null, Validators.required),
      commercialUnitDescription: new FormControl(null, [Validators.required]),
      // TODO: change true to check for value of new construction in type step to 'Yes'
      commercialStatusofConstruction: new FormControl(null, [Validators.required]),
      commercialNeedingServiceDate: new FormControl('', [Validators.pattern(this.constantsSvc.dateValidator)]),
      // TODO: change true to check for value of commercialDeliveryPressure to 'Other'
      commercialDeliveryPressureOthers: new FormControl(''),
      commercialBuildingType: new FormControl(null, [Validators.required]),
      appliancesforCommercial: new FormArray([new FormGroup({
        defaultAppliance: new FormControl(null, [Validators.required]),
        defaultApplianceOther: new FormControl(null),
        quantity: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.numericPattern)]),
        defaultValue: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.numericPatternwithZero)])
      })])
    })
    );
  }
  selectIDforResidential(id, event: any) {
    if (event.target.checked) {
      this.selectedIDsforResidential.push(id);
    } else if (!event.target.checked) {
      const index = this.selectedIDsforResidential.indexOf(id);
      this.selectedIDsforResidential.splice(index, 1);
    }
  }

  // used to autopopulate the BTU value when appliance is selected
  onApplianceSelected(item: any, appArr: FormGroup) {
    appArr.controls['defaultValue'].reset(null);
    appArr.controls['defaultValue'].clearValidators();
    appArr.controls['defaultApplianceOther'].reset(null);
    appArr.controls['defaultApplianceOther'].clearValidators();
    this.btuLoadVal = this.constantsSvc.btuLoadOption;
    if (item['itemName'].toUpperCase() === this.constantsSvc.other) {
      this.btuLoadVal = this.constantsSvc.btuLoadOption;
      appArr.controls['defaultApplianceOther'].setValidators(Validators.required);
      appArr.controls['defaultValue'].setValidators(Validators.pattern(this.constantsSvc.numericPatternwithZero));
      appArr.controls['defaultApplianceOther'].updateValueAndValidity({
        onlySelf: true
      });
      appArr.controls['defaultValue'].updateValueAndValidity({
        onlySelf: true
      });
    } else if ((item['itemName'] === this.constantsSvc.PoolHeater) || (item['itemName'] === this.constantsSvc.standbyGenerator)) {
      this.btuLoadVal = this.constantsSvc.btuLoadOption;
      appArr.controls['defaultValue'].setValidators(Validators.pattern(this.constantsSvc.numericPatternwithZero));
      appArr.controls['defaultValue'].updateValueAndValidity({
        onlySelf: true
      });
      appArr.controls['defaultApplianceOther'].reset(null);
      appArr.controls['defaultApplianceOther'].clearValidators();
    } else {
      this.btuLoadVal = this.constantsSvc.btuLoad;
      const homeSqFt = this.form.controls['residentialHomeSqFt'].value;
      const requestType = item.usageType.toUpperCase() ==='RESIDENTIAL' ? 'RES':'COMM';
    
      const loadValue = this.lookupSvc.wrLoadArmLkp.filter(load => 
        load.loadTypeCode === item.id && load.resiComm === requestType &&
        ((load.minSqFTG === null || load.minSqFTG <= homeSqFt) &&
        (load.maxSqFTG === null || load.maxSqFTG >= homeSqFt))
        );

    if(loadValue.length > 0)
    {
      appArr.controls['defaultValue'].setValue(loadValue[0]['itemName']);
        }

      appArr.controls['defaultApplianceOther'].reset(null);
      appArr.controls['defaultApplianceOther'].clearValidators();
      appArr.controls['defaultValue'].setValidators([Validators.required, Validators.pattern(this.constantsSvc.numericPatternwithZero)]);
    }
    appArr.updateValueAndValidity();
  }

  // used to autopopulate the BTU value when appliance is selected
  onApplianceSelectedCom(eve: any, appArr: FormGroup) {

    appArr.controls['defaultValue'].clearValidators();
    appArr.controls['defaultApplianceOther'].reset(null);
    appArr.controls['defaultApplianceOther'].clearValidators();
    appArr.updateValueAndValidity();

    if (eve['itemName'].toUpperCase() === this.constantsSvc.otherAppliance) {
      appArr.controls['defaultApplianceOther'].setValidators(Validators.required);
      appArr.controls['defaultValue'].setValidators([Validators.required, Validators.pattern(this.constantsSvc.numericPatternwithZero)]);
      appArr.controls['defaultApplianceOther'].updateValueAndValidity();
      appArr.controls['defaultValue'].updateValueAndValidity();
    } else if (eve['itemName'] === this.constantsSvc.PoolHeater || eve['itemName'] === this.constantsSvc.standbyGenerator) {
      this.btuLoadVal1 = this.constantsSvc.btuLoadOption;
      appArr.controls['defaultValue'].setValidators([Validators.required, Validators.pattern(this.constantsSvc.numericPatternwithZero)]);
      appArr.controls['defaultValue'].updateValueAndValidity({
        onlySelf: true
      });
      appArr.controls['defaultApplianceOther'].reset(null);
      appArr.controls['defaultApplianceOther'].clearValidators();
      appArr.controls['defaultApplianceOther'].updateValueAndValidity();
    } else {
      this.btuLoadVal1 = this.constantsSvc.btuLoad;
      appArr.controls['defaultApplianceOther'].reset(null);
      appArr.controls['defaultApplianceOther'].clearValidators();
      appArr.controls['defaultValue'].setValidators([Validators.required, Validators.pattern(this.constantsSvc.numericPatternwithZero)]);
      appArr.controls['defaultApplianceOther'].updateValueAndValidity();
      appArr.controls['defaultValue'].updateValueAndValidity();
    }
    appArr.updateValueAndValidity();
  }

}
